import DefaultAML from './DefaultAML';

export default DefaultAML;
